import { QueryParams } from 'common/urls/QueryParams';
import { CuisineCategory } from 'src/gqlReactTypings.generated.d';
import { UseDishFirstExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { match, P } from 'ts-pattern';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';
import { PageHeroType } from '../Constants';

export type UsePageHeroProps = {
  activeCuisineCategory: CuisineCategory | null;
  isCuisineSegment?: boolean;
  isPageLoading?: boolean;
  showRecommendedShefsLayout?: boolean;
  filters: UseDishFirstExploreUrl;
};

export const usePageHeroType = (props: UsePageHeroProps) => {
  const {
    activeCuisineCategory,
    isCuisineSegment = false,
    isPageLoading = false,
    showRecommendedShefsLayout = false,
    filters,
  } = props;

  const [{ sa }] = useQueryParams({
    [QueryParams.SEE_ALL]: withDefault(StringParam, undefined),
  });

  const pageHeroType = match({
    hasCuisineCommunityPage: !!activeCuisineCategory?.categoryPageContent,
    isPageLoading,
    browseFilter: filters.browseFilter,
    isCuisineSegment,
    showRecommendedShefsLayout,
    sa,
  })
    .with({ isPageLoading: true }, () => PageHeroType.Loading)
    .with({ hasCuisineCommunityPage: true, browseFilter: P.not(P.nullish) }, () => PageHeroType.CuisineCategoryPage)
    .with(
      { browseFilter: P.not(P.nullish), showRecommendedShefsLayout: true },
      () => PageHeroType.FilterBannerRecommendedShefs
    )
    .with({ browseFilter: P.not(P.nullish), sa: P.not(P.nullish) }, () => PageHeroType.FilterBanner)
    .with({ isCuisineSegment: false, showRecommendedShefsLayout: false }, () => PageHeroType.Main)
    .with({ showRecommendedShefsLayout: true }, () => PageHeroType.RecommendedShefs)
    // Should have an error state here?
    .otherwise(() => PageHeroType.Loading);

  return {
    pageHeroType,
    showBrowseFilterBanner:
      pageHeroType === PageHeroType.FilterBanner || pageHeroType === PageHeroType.FilterBannerRecommendedShefs,
  };
};
